<script setup lang="ts">
const prefix = 'components.legal.legalNotices';
</script>

<template>
  <div>
    <div class="w-full bg-secondary px-4 pb-5 pt-10 md:px-6 lg:px-8">
      <UiCustomContainer>
        <NuxtLinkLocale
          to="index"
          class="mb-8 inline-flex items-center gap-2 text-gray-600 hover:text-gray-800"
        >
          <SvgoCommonArrowLeft
            filled
            :font-controlled="false"
            class="mt-0.5 h-5 w-5"
          />
          <span class="font-semibold">{{ $t(`${prefix}.backToHome`) }}</span>
        </NuxtLinkLocale>

        <h1 class="mb-10 text-pretty text-center text-3xl font-bold">
          {{ $t('pages.legalNotices.seo.title') }}
        </h1>
      </UiCustomContainer>
    </div>

    <div class="flex w-full justify-center px-4 py-10 md:px-6 lg:px-8">
      <div class="max-w-container">
        <div class="mb-8 flex items-center gap-2 text-sm text-gray-600">
          <SvgoLegalClock filled />
          <span>{{ $t(`${prefix}.updatedAt`) }}</span>
        </div>

        <div class="space-y-6 text-secondary-foreground">
          <!-- Section 1: Company -->
          <div>
            <h2 class="pb-4 text-xl font-medium text-foreground md:text-2xl">{{ $t(`${prefix}.s1.title`) }}</h2>

            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.description`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.capital`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.siege`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.rcs`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.siret`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.tva`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.ape`) }}</p>
          </div>

          <!-- Section 2: Travel agency -->
          <div>
            <h2 class="pb-4 pt-6 text-xl font-medium text-foreground md:text-2xl">
              {{ $t(`${prefix}.s2.title`) }}
            </h2>

            <p class="pb-4 text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.description`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.atoutFrance`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.apst`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.iata`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.edv`) }}</p>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.insurance`) }}</p>
          </div>

          <!-- Section 3: Publication director -->
          <div>
            <h2 class="pb-4 pt-6 text-xl font-medium text-foreground md:text-2xl">
              {{ $t(`${prefix}.s3.title`) }}
            </h2>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.director`) }}</p>
          </div>

          <!-- Section 4: Hosting -->
          <div>
            <h2 class="pb-4 pt-6 text-xl font-medium text-foreground md:text-2xl">
              {{ $t(`${prefix}.s4.title`) }}
            </h2>

            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.description`) }}</p>

            <div class="mb-4">
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.aws1`) }}</p>
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.aws2`) }}</p>
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.aws3`) }}</p>
            </div>

            <div>
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.ovh1`) }}</p>
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.ovh2`) }}</p>
              <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.ovh3`) }}</p>
            </div>
          </div>

          <!-- Section 5: CNIL -->
          <div>
            <h2 class="pb-4 pt-6 text-xl font-medium text-foreground md:text-2xl">
              {{ $t(`${prefix}.s5.title`) }}
            </h2>
            <p class="text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p1`) }}</p>
          </div>

          <!-- Section 6: Contact -->
          <div>
            <h2 class="pb-4 pt-6 text-xl font-medium text-foreground md:text-3xl">
              {{ $t(`${prefix}.s6.title`) }}
            </h2>
            <p class="text-base font-normal md:text-lg">
              {{ $t(`${prefix}.s6.p1Before`) }}
              <NuxtLink
                to="mailto:contact@optionway.com"
                class="text-foreground underline"
              >
                contact@optionway.com
              </NuxtLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
